module.exports = __webpack_public_path__ + "img/banner3.d0b6796e.png";